import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover, Tabs } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";

const { confirm } = Modal;

const NotesTable = ({
      bookMark,
      roles,
      page,
      setPage,
      totalPages,
      totalEntries,
      sort,
      order,
      setOrder,
      setSort,
      search,
      setSearch,
      fetchBookMark,
      onView,
      entriesPerPage,
      setEntriesPerPage
}) => {
      const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
      const [loading, setLoading] = useState(false);
      const navigate = useNavigate();

      const headerConfig = [
            { key: "user_name", label: "User Name", sortable: false },
            { key: "title", label: "Title", sortable: false },
            { key: "content", label: "Content", sortable: false },
            { key: "created_at", label: "Created At", sortable: false },
            { key: "updated_at", label: "Updated At", sortable: false },
      ];

      // console.log("notes table =====>", bookMark);

      if (loading) return <ContentLoader />;

      return (
            <div className="card basic-data-table text-sm overflow-x-auto">
                  <div className="card-header responsive-header d-flex justify-content-end align-items-center global-header">
                        <div className="d-flex align-items-center gap-3">
                              {/* Refresh Icon */}
                              <Icon
                                    icon="mdi:refresh"
                                    width="26"
                                    height="26"
                                    className="ms-2 text-lg d-none d-md-inline-flex refresh-icon "
                                    onClick={fetchBookMark}
                              />

                              <div className="search-container" style={{ gap: "10px" }}>
                                    <SearchBy
                                          value={search}
                                          onChange={(e) => {
                                                setSearch(e.target.value);
                                                setPage(1);
                                          }}
                                    />
                              </div>
                        </div>
                  </div>
                  <div className="card-body card-body-modify">
                        <div className="w-full overflow-x-auto">
                              <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                                    <thead>
                                          <tr>
                                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                                          </tr>
                                    </thead>
                                    <tbody>
                                          {Array.isArray(bookMark) && bookMark.length > 0 ? (
                                                bookMark.flatMap((item) =>
                                                      item.notes.map((note) => (
                                                            <tr key={note.id}>

                                                                  {/* User */}
                                                                  <td className="d-flex align-items-center gap-2">
                                                                        <ImagePreviewModal
                                                                              src={item.user?.avatar || "/assets/images/logo-profile.png"}
                                                                              fallback="/assets/images/logo-profile.png"
                                                                              alt={item.user?.name}
                                                                              thumbWidth={40}
                                                                              thumbHeight={40}
                                                                        />
                                                                        <span>{item.user?.name}</span>
                                                                  </td>

                                                                  {/* Title */}
                                                                  <td>{note.title || "-"}</td>

                                                                  {/* Content */}
                                                                  <td className="text-truncate" style={{ maxWidth: "250px" }}>
                                                                        {note.content || "-"}
                                                                  </td>

                                                                  {/* Created At */}
                                                                  <td>
                                                                        {formatDateToDMY(note.created_at)} <br />
                                                                        <span className="text-muted">{formatTime12Hour(note.created_at)}</span>
                                                                  </td>

                                                                  {/* Updated At */}
                                                                  <td>
                                                                        {formatDateToDMY(note.updated_at)} <br />
                                                                        <span className="text-muted">{formatTime12Hour(note.updated_at)}</span>
                                                                  </td>

                                                            </tr>
                                                      ))
                                                )
                                          ) : (
                                                <tr>
                                                      <td colSpan={4} className="text-center">
                                                            No Notes found
                                                      </td>
                                                </tr>
                                          )}
                                    </tbody>
                              </table>
                        </div>
                        <Pagination
                              page={page}
                              setPage={setPage}
                              totalPages={totalPages}
                              totalEntries={totalEntries}
                              entriesPerPage={entriesPerPage}
                              setEntriesPerPage={setEntriesPerPage}
                        />
                  </div>
            </div>
      );
};

export default NotesTable;